<template>
    <div>
        <div class="row form-group">
            <div :class="labelCol">
                รหัสพนักงาน
            </div>
            <div :class="inputCol">
                <multiselect
                    v-model="form.employee"
                    placeholder="เลือกพนักงาน"
                    :options="employeeOption"
                    :customLabel="employeeLabel"
                    :show-labels="false"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div :class="labelCol">สินค้าโรงงาน</div>
            <div :class="inputCol">
                <input class="form-control" v-model="form.factory.code" disabled/>
            </div>
        </div>
        <div class="row form-group">
            <div :class="labelCol">จำนวนนำเข้า</div>
            <div :class="inputCol">
                <input class="form-control" type="number" v-model="form.quantity"/>
            </div>
        </div>
        <div class="row form-group">
            <div :class="labelCol">วันที่</div>
            <div :class="inputCol">
                <date-picker :lang="lang"
                             v-model="form.date"
                             :format="changeFormat"
                             class="w-100"
                             placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด" confirm>
                </date-picker> &nbsp;
            </div>
        </div>
        <div class="col text-center">
            <button type="button" class="btn btn-success" @click="submitData">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button>
            &nbsp;&nbsp;
            <button class="btn btn-outline-secondary" @click="cancelData">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
            &nbsp;&nbsp;
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'
import moment from 'moment';
import {mapState} from "vuex";

export default {
    name: "FactoryExportModal",
    components: {
        Multiselect,
        DatePicker
    },
    created() {
        this.$store.dispatch("Employee/getEmployeeAll").then(employee => {
            this.employeeOption = employee;
        });
    },
    computed: {
        ...mapState({
            form: state => {
                return state.FactoryEmployeeExport.form
            }
        })
    },
    watch: {
        factory(val) {
            this.form.factory = val;
        }
    },
    data() {
        return {
            employeeOption: [],
            inputCol: 'col-6 col-xs-12',
            labelCol: 'col-4 col-xs-12 text-right',
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        cancelData() {
            this.$emit("submit", false);
        },
        submitData() {
            this.form.employee_id = this.form.employee ? this.form.employee.id : '';
            this.$emit("submit", this.form);
        },
    }
}
</script>

<style scoped>

</style>
